var __TEMP__ = require('./_cloneArrayBuffer.js');var cloneArrayBuffer = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = cloneTypedArray;
